import { Container, Grid } from '@mui/material';
import FlowChartOfHowItWorkContent from './FlowChartOfHowItWorkContent';
import FlowChartOfHowItWorkTitle from './FlowChartOfHowItWorkTitle';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  FlowChartOfHowItWorkBg: {
    // padding: [[155, 0, 0, 0]],
    paddingTop: 155,
    backgroundColor: '#04B078',

    '& h2': {
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '30px',
      lineHeight: '34px',
      letterSpacing: '0.3em',
      color: '#fff',
      paddingBottom: '43px',
    },

    '& p': {
      fontWeight: '300',
      fontSize: '20px',
      lineHeight: '28px',
      textAlign: 'center',
      color: '#fff',
    },
  },
}));

export default function FlowChartOfHowItWork({ title, content }) {
  const classes = useStyles();

  return (
    <div className={classes.FlowChartOfHowItWorkBg}>
      <Container fixed={true}>
        <FlowChartOfHowItWorkTitle title={title} />
        <Grid container direction="row" justify="center">
          <Grid item md={2} />
          <Grid item md={8}>
            <FlowChartOfHowItWorkContent content={content} />
          </Grid>
          <Grid item md={2} />
        </Grid>
      </Container>
    </div>
  );
}
